import _, { get } from 'lodash';
import { GridSettings } from '../samwebDescription/samweb/dashboard/grid-column-settings';
import { DirectoryColumn } from '../samwebDescription/samweb/directory/directory-column';
import { SettingItem } from '../store/dashboard/brick-wall/brick-behaviour-state/brick-grids-state/brick-grids.state';

export function samSort<T>(array: T[], field: string, direction: 'asc' | 'desc' = 'desc'): T[] {
   if (_.isNil(array) || _.isEmpty(array)) {
      return [];
   }
   const isString =
      _(array)
         .map(field)
         .map((item) => typeof item)
         .first() === 'string';
   if (isString) {
      return _.orderBy(array, (item) => [get(item, field)].toString().toLowerCase(), direction);
   }
   return _.orderBy(array, [field], [direction]);
}

export function directoryGridOrder(editableColumns: DirectoryColumn[], setting: GridSettings): DirectoryColumn[] {
   const sortSettings = _(editableColumns)
      .map(
         (dir, index) =>
            new SettingItem(
               dir?.directoryColumnKey,
               setting?.columnsConfig[dir.directoryColumnKey]?.isHidden ?? !dir.columnTyp?.isDefaultVisible ?? true
                  ? index + 1000
                  : setting?.columnsConfig[dir.directoryColumnKey]?.orderIndex ?? index + 100
            )
      )
      .orderBy((entry) => entry.index)
      .map(
         (entry, index) =>
            new SettingItem(
               entry.field,
               !_.isNil(setting?.columnsConfig[entry.field]?.orderIndex) ? setting?.columnsConfig[entry.field]?.orderIndex * 10 + 1 : index * 10
            )
      )
      .orderBy((entry) => entry.index)
      .map((entry, index) => new SettingItem(entry.field, index))
      .value();
   const sortOrder: {
      [columnkey: string]: number;
   } = {};
   sortSettings.forEach((order) => {
      sortOrder[order.field] = order.index;
   });
   return _(editableColumns)
      .orderBy((dir) => sortOrder[dir.directoryColumnKey])
      .value();
}
